import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "topbar d-flex align-items-stretch flex-shrink-0 gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "align-items-center me-n3 ms-1 ms-lg-3 d-none d-lg-flex"
}
const _hoisted_4 = {
  key: 1,
  class: "align-items-center me-n3 ms-1 ms-lg-3 d-none d-lg-flex"
}
const _hoisted_5 = {
  key: 2,
  class: "align-items-center me-n3 ms-1 ms-lg-3 d-none d-lg-flex"
}
const _hoisted_6 = {
  class: "d-flex align-items-center me-n3 ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_7 = {
  class: "ms-3 btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px symbol symbol-35px symbol-md-40px d-none d-lg-block",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}

import { computed, ref } from "vue";
import KTUserMenu from "@/layouts/client-layout/header/partials/UserMenu.vue";
import { useStore } from "@/store";
import BPWSNotify from "@/layouts/client-layout/notify/WSNotify.vue";
import { PublicSetting } from "@/core/types/ConfigTypes";


const __default__ = {
  name: "layout-topbar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const currentAgentAccount = computed(
  () => store.state.AgentModule?.agentAccount
);
const currentSalesAccount = computed(
  () => store.state.SalesModule?.salesAccount
);
const currentRepAccount = computed(() => store.state.RepModule?.repAccount);
const user = store.state.AuthModule.user;
var siteColors = {
  au: "#7a9e7a",
  bvi: "#fa6b6c",
  sea: "#349beb",
  mn: "#b497b4",
  jp: "#f6c23e",
};
const siteColor = ref(siteColors[user.tenancy]);

const projectConfig = computed<PublicSetting>(
  () => store.state.AuthModule.config
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BPWSNotify),
      (
          _ctx.$cans(['IB']) && currentAgentAccount.value?.uid > 0 && projectConfig.value
            ? projectConfig.value.ibEnabled
            : false
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "btn btn-sm btn-primary",
              to: "/ib"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("title.ibCenter")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.$cans(['Sales']) && currentSalesAccount.value?.uid > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "btn btn-sm btn-secondary",
              to: "/sales"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("title.salesCenter")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.$cans(['Rep']) && currentRepAccount.value?.uid > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "btn btn-sm btn-secondary",
              to: "/rep"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("title.repCenter")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_unref(user))
            ? (_openBlock(), _createBlock(_component_UserAvatar, {
                key: 0,
                avatar: _unref(user)?.avatar,
                name: _unref(user)?.name,
                rounded: "",
                side: "client",
                size: "40px"
              }, null, 8, ["avatar", "name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            style: _normalizeStyle('background-color: ' + siteColor.value + ';'),
            class: "headerSite"
          }, null, 4)
        ]),
        _createVNode(KTUserMenu)
      ])
    ])
  ]))
}
}

})